import React, { useEffect, useRef, useState } from 'react'
import { useLocation } from 'react-router-dom';
import MainTitleBreadcrumb from './MainTitleBreadcrumb';
import "../css/MainTitle.css"
import SplitType from 'split-type';
import * as imagesdata from '../imagesdata'

import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);
export const MainTitle = ({ headerImage }) => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const imageRef = useRef(null);
    const h1Ref = useRef(null);
    const [modelRequestName, setModelRequestName] = useState("")
    const [pageWidth, setPageWidth] = useState(window.innerWidth)
    const [fontSize, setFontSize] = useState(10);
    const [rhombusWidth, setRhombusWidth] = useState();
    const modelName = searchParams.get('model');
    const [h1Width, setH1Width] = useState(h1Ref.current && h1Ref.current.offsetWidth);
    const [h1Height, setH1Height] = useState(h1Ref.current && h1Ref.current.offsetHeight);
    useEffect(() => {
        if (location.pathname == "/urunler") {
            if (modelName == null || modelName == '') {
                setModelRequestName("Tüm Ürünlerimiz")
            }
            else if (modelName == "PERVAZ") {
                setModelRequestName("Pervazlar");
            }
            else if (modelName == "KASA") {
                setModelRequestName("Kasalar");
            }
            else if (modelName) {
                const formattedModelName = modelName.charAt(0).toUpperCase() + modelName.slice(1).toLowerCase();
                setModelRequestName(`${formattedModelName} Kapı Modelleri`);
            }
        }
        else if (location.pathname == "/biz-kimiz") {
            setModelRequestName("Biz Kimiz?");
        }
        else if (location.pathname == "/surecler") {
            setModelRequestName("Üretim Süreçlerimiz");
        }
        else if (location.pathname == "/referanslar") {
            setModelRequestName("Referanslarımız");
        }
        else if (location.pathname == "/iletisim") {
            setModelRequestName("İletişim");
        }
        else if (location.pathname == "/e-katalog") {
            setModelRequestName("E-Katalog");
        }
        else if (location.pathname == "/trafik-akisi") {
            setModelRequestName("Trafik Akışı");
        }
    }, [location.pathname]);

    useEffect(() => {
        const myText = new SplitType('#main-title-text');

        const tl = gsap.timeline();

        tl
            .to('.text-rhombus', {
                left: 0,
                delay: 0.7,
                duration: 1,
                ease: "power2.out"
            })

            .to('.text-rhombus', {
                rotation: 0,
                duration: 0.3,
                ease: "power2.out"
            })

            .to('.text-outline-rhombus', {
                left: 15,
                duration: 0.3,
                ease: "power2.out"
            })

            .to('.char', {
                y: 10,
                stagger: 0.05,
                duration: 0.001,
                ease: "power2.out"
            })

            .to('.main-title-breadcrumb-header', {
                opacity: 1,
                visibility: 'visible',
                duration: 0.3,
                delay: 1,
                ease: "power2.out"
            });
        return () => {
            myText.revert();
        };
    }, [modelRequestName])

    useEffect(() => {
        gsap.to(imageRef.current, {
            y: (i, target) => {
                return target.clientHeight * 0.7;
            },
            ease: 'none',
            scrollTrigger: {
                trigger: imageRef.current,
                start: 'top top',
                end: 'bottom top',
                scrub: true,
            },
        });
    }, []);


    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth
            const newFontSize = Math.max(20, Math.min(60, (width / 25)));
            const newRhombusWidth = Math.max(90, Math.min(180, (width / 7)));
            if (h1Ref.current) {
                setH1Width(h1Ref.current.offsetWidth);
                setH1Height(h1Ref.current.offsetHeight)
            }
            setFontSize(newFontSize);
            setRhombusWidth(newRhombusWidth)
            setPageWidth(width)
        };

        window.addEventListener("resize", handleResize);

        handleResize();

        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);

    return (
        <div className='main-title-container'>
            <div className='products-header-image-modal' />
            <img className='products-header-image' ref={imageRef} src={headerImage} alt="Products Header" />

            <div className="main-title-text-header">
                <h1 id="main-title-text" className="main-title-text" ref={h1Ref} style={{ fontSize: `${fontSize}px` }}>
                    {modelRequestName && modelRequestName}
                </h1>
            </div>
            <div className='text-rhombus-header'>
                <span className='text-rhombus' style={{ width: `${rhombusWidth}px`, height: `${rhombusWidth / 2}px` }}></span>
                <span className='text-rhombus text-outline-rhombus' style={{ width: `${rhombusWidth}px`, height: `${rhombusWidth / 2}px` }}></span>
                <h1 id="main-title-text" className="main-title-text" style={{ fontSize: `${fontSize}px`, opacity: "0" }}>
                    {modelRequestName && modelRequestName}
                </h1>
            </div>
            <div className='main-title-breadcrumb-header'>
                <MainTitleBreadcrumb />
            </div>
        </div>
    )
}
